"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CardContainer = _interopRequireDefault(require("../cardContainer/CardContainer"));

var _Image = _interopRequireDefault(require("../../../atoms/images/image/Image"));

var _ThirdPartyIcon = _interopRequireDefault(require("../../../protons/icons/ThirdPartyIcon"));

var _Typography = _interopRequireDefault(require("../../../protons/typography/Typography"));

var _CardContent = _interopRequireDefault(require("../cardContainer/CardContent"));

var _CardAction = _interopRequireDefault(require("../cardContainer/CardAction"));

var _BoxPosition = _interopRequireDefault(require("../../../layouts/box/boxPosition/BoxPosition"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardPromotional = function CardPromotional(_ref) {
  var src = _ref.src,
      primary = _ref.primary,
      secondary = _ref.secondary,
      icon = _ref.icon,
      _action = _ref.action;
  return /*#__PURE__*/_react.default.createElement(_CardContainer.default, null, /*#__PURE__*/_react.default.createElement(_CardAction.default, {
    action: function action() {
      return _action();
    }
  }, /*#__PURE__*/_react.default.createElement(_BoxPosition.default, {
    position: "relative"
  }, /*#__PURE__*/_react.default.createElement(_Image.default, {
    ratio: "1x1",
    src: src
  }), /*#__PURE__*/_react.default.createElement(_BoxPosition.default, {
    position: "absolute",
    left: "large",
    bottom: "nMedium"
  }, /*#__PURE__*/_react.default.createElement(_ThirdPartyIcon.default, {
    icon: icon
  }))), /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "Anthracite",
    component: "div",
    text: secondary,
    variant: "body"
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    bold: true,
    color: "VfGrey",
    component: "div",
    text: primary,
    variant: "h3"
  }))));
};

CardPromotional.propTypes = {
  /** The image url to show */
  src: _propTypes.default.string.isRequired,

  /** The primary text of the card */
  primary: _propTypes.default.string.isRequired,

  /** The secondary text */
  secondary: _propTypes.default.string,

  /** The third party icon see #protons-icons-thirdparty--icon */
  icon: _propTypes.default.string.isRequired,

  /** The action of the card */
  action: _propTypes.default.func.isRequired
};
CardPromotional.defaultProps = {
  secondary: null
};
var _default = CardPromotional;
exports.default = _default;